import { UserRoles } from '@app/core/enums/roles.enum';

export const BACKOFFICE_SELF_ASSIGN_ROLES: UserRoles[] = [
  UserRoles.IS_BACK_OFFICE,
  UserRoles.IS_PROPERTY_FINDER,
  UserRoles.IS_ADMIN,
];

export const BACKOFFICE_SELF_ASSIGN_EVENT_TYPES = [3, 4, 5, 6, 9, 13, 14, 16];

export const BACKOFFICE_SELF_ASSIGN_VIRTUAL_MEDIUM_EVENT_TYPES = [9, 13, 14];

export function hasBackofficeSelfAssignRole(roles: readonly string[] | undefined): boolean {
  return roles?.some((role) => BACKOFFICE_SELF_ASSIGN_ROLES.includes(role as UserRoles)) ?? false;
}

export function selfAssignSlotAccountLabel(assignToSelf: boolean, email: string): string {
  return assignToSelf ? 'Io' : email;
}
